export const taskImages = {
  task_edit_icon: 'assets/img/task-edit.svg',
  popup_close_image: 'assets/new-img/icons/popup-close.png',
  refresh_task_icon: 'assets/img/refresh-task.svg',
  task_1_icon: 'assets/menu-customisation-icons/Tasks/tasks1.svg',
  task_2_icon: 'assets/menu-customisation-icons/Tasks/tasks2.svg',
  task_3_icon: 'assets/menu-customisation-icons/Tasks/tasks3.svg',
  task_4_icon: 'assets/menu-customisation-icons/Tasks/tasks4.svg',
  task_5_icon: 'assets/menu-customisation-icons/Tasks/tasks5.svg',
  task_6_icon: 'assets/menu-customisation-icons/Tasks/tasks6.svg',
  task_7_icon: 'assets/menu-customisation-icons/Tasks/tasks7.svg',
};
